import { render, staticRenderFns } from "./DepartmentTreeNodeWithOpenData.vue?vue&type=template&id=044b3de0"
import script from "./DepartmentTreeNodeWithOpenData.vue?vue&type=script&lang=js"
export * from "./DepartmentTreeNodeWithOpenData.vue?vue&type=script&lang=js"
import style0 from "./DepartmentTreeNodeWithOpenData.vue?vue&type=style&index=0&id=044b3de0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports